import React, { useState, useEffect, useRef } from "react";
import CompanyHeader from "../../components/CompanyHeader";
import CompanySideMenu from "../../components/CompanySideMenu";
import { useNavigate, useParams } from "react-router-dom";
import Dropdown from "../../components/Dropdown";
import CheckboxButton from "../../components/CheckboxButton";
import { TypeOptions } from "./components/TypeOptions";
import RadioGroup from "../../components/RadioGroup";
import CustomDatePicker from "../../components/CustomDatePicker";
import TextInput from "../../components/TextInput";
import CustomTextarea from "../../components/CustomTextarea";
import { validateRequired, validateOptionsRequired, isValidTagString } from "../../utils/validation"
import { useSnackbar } from "notistack";
import CustomToast from "../../components/CustomToast";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import { formatTime, dateToString } from "../../utils/format";
import {LoadingSpinner} from "../../components/Icons";
import { 
  setErrorMsg, createJob, setIsNavigateToPreview, setIsNavigateToEdit, setSuccess, setError,
  getJobDetail, updateJobDetail, setJobDetailData, setJobDetailDataTemp, setActionName,
  setIsChangeBeforePreview,
} from "../../reducers/companyJob";
import { setIsOpenSearchTagsPanel } from "reducers/talentTag";
import { getTalentTagOptions } from "reducers/companyTalent";
import { PERMISSIONS, RECRUITMENT_STATUS } from '../../constants/index';
import ReturnButton from "../../components/ReturnButton";
import CustomButton from "../../components/CustomButton";
import NotFoundPage from "../../pages/NotFoundPage";
import Copyright from "../../components/Copyright";
import CustomSwitch from "../../components/CustomSwitch";
import dayjs from 'dayjs';
import TimeInput from "../../components/TimeInput";
import { getMinPublicTime, getTimeErrorMessage } from "../../utils/util";
import i18n from 'i18next';
import { allOptionsLoadedSelector } from "../../selectors/companyJobSelectors";
import UnsaveConfirmPopup from "../action/components/UnsaveConfirmPopup";
import { setIsFormDirty, setShowLeaveConfirm } from "../../reducers/app";
import CustomTag from "../../components/CustomTag";

const initialData = {
  title: "", tags: null, tag_condition: null, jobType1: null, jobType2: null, jobType3: null,
  industry1: null, industry2: null, industry3: null, prefecture: null, municipalities: "",
  street_address: "", nearest_station: "", work_location_notes: "", from_income: null,
  to_income: null, post: null, department: "", department_message: "", company_info: "",
  smoking_measure: null, insurance_benefit_note: "", allowance_note: "", vacation_note: "",
  annual_holiday: "", employment_status: null, employment_status_note: "", working_style: null,
  break_time: "", ot_pay_note: "", employee_quantity: "", pay_type: null, from_monthly_fee: "",
  to_monthly_fee: "", salary_increase: null, wage_remarks: "", selection_process: "",
  job_description: "", scope_of_change: false, scope_of_change_note: "", tag: "", avg_ot_hours: "", 
  fixed_ot_pay: null, bonus: "", trial_period: null, trial_period_time: "", from_age: "", to_age: "", 
  application_deadline: null, holiday_vacation: null, from_working_hour: "", from_working_minute: "", 
  to_working_hour: "", to_working_minute: "", recruitment_status: null, public_schedule_hour: null, 
  public_schedule_minute: null, application_deadline_hour: null, application_deadline_minute: null, admin_note: ""
};

const NewJobCreation = () => {
  const { allowancesOptions, employmentStatus, holidayAndVacationsRadioOptions, insuranceBenefitsOptions,
    jobTypeOptions, industryOptions, maternityLeaveOptions, measuresAgainstPassiveSmoking, payTypes,
    prefectures, recruitmentStatus, workingStyles, noAgeLimitOptions, increaseForOverTimeOptions,
    roleOptions, fixedOTpayment, hasSalaryIncrement, probationDuration, talentTypeOptions, tagLogicTypes
  } = TypeOptions();

  const allOptionsLoaded = useSelector(allOptionsLoadedSelector);

  const navigate = useNavigate();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const currentUser = useSelector((state: any) => state.currentUser);
  const { staffPermission } = currentUser;
  const {company} = currentUser.staffInfo
  const { loading, success, error, actionName, actionStatus, isNavigateToPreview,
          isNavigateToEdit, jobDetailData, jobDetailDataTemp, isChangeBeforePreview,
  } = useSelector((state: any) => state.companyJob);
  const {talentTagOptions} = useSelector((state: any) => state.companyTalent);
  const {isFormDirty, showLeaveConfirm, isNavigatingAway} = useSelector((state: any) => state.app);
  const { id } = useParams<{ id: string }>();
  const [checkingAccess, setCheckingAccess] = useState(true);
  const [jobType1Options, setJobType1Options] = useState([]);
  const [jobType2Options, setJobType2Options] = useState([]);
  const [jobType3Options, setJobType3Options] = useState([]);
  const [industry1Options, setIndustry1Options] = useState([]);
  const [industry2Options, setIndustry2Options] = useState([]);
  const [industry3Options, setIndustry3Options] = useState([]);
  const jobType2DropdownRef = useRef<HTMLDivElement>(null)
  const jobType3DropdownRef = useRef<HTMLDivElement>(null)
  const industry1DropdownRef = useRef<HTMLDivElement>(null)
  const industry2DropdownRef = useRef<HTMLDivElement>(null)
  const industry3DropdownRef = useRef<HTMLDivElement>(null)
  const [isLeavePage, setIsLeavePage] = useState(false);
  const [urlLeave, setUrlLeave] = useState('');

  useEffect(() => {
    if(id){
      const data = { id: Number(id) }
      dispatch(getJobDetail(data));
      if (Number(id) !== Number(jobDetailDataTemp?.id)) dispatch(setJobDetailDataTemp(null));
    } else{
      dispatch(setJobDetailData([]))
    }
  }, [id]);

  useEffect(() => {
    dispatch(setIsChangeBeforePreview(false));
    if(!jobDetailData?.id) {
      dispatch(setIsFormDirty(false));
      dispatch(setShowLeaveConfirm(false));
    }
  }, [])

  useEffect(() => {
    if (!id) {
      if (staffPermission && staffPermission.hasOwnProperty(PERMISSIONS.JOB_NEW)) {
        setCheckingAccess(false);
      }
    } else {
      if (staffPermission && staffPermission.hasOwnProperty(PERMISSIONS.JOB_EDIT) &&
        (jobDetailData?.id || error)
      ) {
        setCheckingAccess(false);
      }
    }
    if(jobDetailData?.id && jobDetailData?.is_draft) {
        dispatch(setIsFormDirty(true));
        dispatch(setShowLeaveConfirm(false));
    }
  }, [id, staffPermission, jobDetailData?.id, error]);

  useEffect(() => {
    setJobType1Options(jobTypeOptions.filter(item => item.parent_id == 0))
    setJobType2Options([])
    setJobType3Options([])

    // Handle load list option: 職種
    handleReloadListOptionJobType()
  }, [jobTypeOptions]);

  useEffect(() => {
    setIndustry1Options(industryOptions.filter(item => item.parent_id == 0))
    setIndustry2Options([])
    setIndustry3Options([])

    // Handle load list option: 業種
    handleReloadListOptionIndustry()
  }, [industryOptions]);

  const [formData, setFormData]: any = useState(initialData);
  const [insuranceBenefits, setInsuranceBenefits] = useState(insuranceBenefitsOptions);
  const [allowances, setAllowances] = useState(allowancesOptions);
  const [maternityLeave, setMaternityLeave] = useState(maternityLeaveOptions);
  const [increaseForOverTime, setIncreaseForOverTime] = useState(increaseForOverTimeOptions);
  const [noAgeLimit, setNoAgeLimit] = useState(noAgeLimitOptions);
  const [isPublishReserved, setIsPublishReserved] = useState(false);
  const [talentType, setTalentType] = useState(talentTypeOptions);
  const [searchTagQuery, setSearchTagQuery] = useState("");

  useEffect(() => {
    dispatch(getTalentTagOptions({searchQuery: searchTagQuery}));
  }, [searchTagQuery]);

  const measuresAgainstPassiveSmokingOptions = measuresAgainstPassiveSmoking.map((option) => {return option});

  const initializeOriginalDate = (originalDate: any) => {
    let date: any, hour: any, minute: any;
    date = hour = minute = null;

    if (originalDate) {
      const originalDatetime = dayjs(originalDate)
      date = originalDatetime.format('YYYY-MM-DD');
      hour = originalDatetime.format('HH');
      minute = originalDatetime.format('mm');
    }
    hour = hour ? hour : "";
    minute = minute ? minute : "";
    return {date, hour, minute};
  }
  
  useEffect(() => {
    if (!allOptionsLoaded) return;

    if (jobDetailData.id) {
      let detailData = { ...jobDetailData }
      if (jobDetailDataTemp) {
        detailData = { ...jobDetailDataTemp }
        detailData.talent_types = jobDetailDataTemp.talent_types.split(',');
        const tags = jobDetailDataTemp?.tags?.split(",")
        detailData.tags = talentTagOptions?.filter(item => tags?.includes(String(item.id)))
      } else {
        detailData = {
          ...jobDetailData,
          jobType1: jobDetailData.occupation_1,
          jobType2: jobDetailData.occupation_2,
          jobType3: jobDetailData.occupation_3,
          industry1: jobDetailData.industry_1,
          industry2: jobDetailData.industry_2,
          industry3: jobDetailData.industry_3,
          prefecture: { "id":	jobDetailData.location_city.id,  "name":	jobDetailData.location_city.label },
          municipalities: jobDetailData.location_village,
          street_address: jobDetailData.location_building,
          nearest_station: jobDetailData.location_station,
          work_location_notes: jobDetailData.location_note,
          from_income: jobDetailData.annual_salary_min,
          to_income: jobDetailData.annual_salary_max,
          post: { "id":	jobDetailData.role?.id, "name":	jobDetailData.role?.label },
          department_message: jobDetailData.message_from_department,
          smoking_measure: jobDetailData.void_smoking_policy,
          insurance_benefit_note: jobDetailData.insurance_note,
          allowance_note: jobDetailData.bonus_note,
          vacation_note: jobDetailData.working_off_days_note,
          annual_holiday: jobDetailData.annual_working_off_day,
          employment_status: { "id":	jobDetailData.type?.id, "name":	jobDetailData.type?.label },
          employment_status_note: jobDetailData.type_note,
          working_style: { "id":	jobDetailData.working_style?.id, "name":	jobDetailData.working_style?.label },
          ot_pay_note: jobDetailData.fixed_OT_payment_note,
          employee_quantity: jobDetailData.persons_to_hire,
          pay_type: { "id":	jobDetailData.salary_payment_method?.id, "name":	jobDetailData.salary_payment_method?.label },
          from_monthly_fee: jobDetailData.monthly_salary_min,
          to_monthly_fee: jobDetailData.monthly_salary_max,
          salary_increase: hasSalaryIncrement.find(item => item.value === (jobDetailData.has_salary_increment === 'True'))?.value,
          wage_remarks: jobDetailData.wage_note,
          job_description: jobDetailData.description,
          scope_of_change: jobDetailData.is_change_scope,
          scope_of_change_note: jobDetailData.change_scope,
          avg_ot_hours: jobDetailData.monthly_average_ot_hours,
          fixed_ot_pay: fixedOTpayment.find(item => item.value === (jobDetailData.fixed_OT_payment === 'True'))?.value,
          bonus: jobDetailData.bonuses_per_year || "",
          trial_period: probationDuration.find(item => item.value === (jobDetailData.probation_duration === 'True'))?.value,
          trial_period_time: jobDetailData.probation_months,
          from_age: jobDetailData.applicant_age_min || "",
          to_age: jobDetailData.applicant_age_max || "",
          application_deadline: jobDetailData.expiry_date,
          holiday_vacation: jobDetailData.days_off_pattern,
          from_working_hour: formatTime(jobDetailData.working_hour_from, "HH"),
          from_working_minute: formatTime(jobDetailData.working_hour_from, "mm"),
          to_working_hour: formatTime(jobDetailData.working_hour_to, "HH"),
          to_working_minute: formatTime(jobDetailData.working_hour_to, "mm"),
          recruitment_status: { "id":	jobDetailData.status?.id, "name":	jobDetailData.status?.label, "value":	jobDetailData.status?.value},
          company_info: company.description ? company.description : company.name,
          tags: talentTagOptions?.filter(item => detailData?.tags?.includes(item.id)),
          tag_condition: tagLogicTypes?.find(item => item.id == jobDetailData.tag_logic),
          talentType: talentType.filter(item => detailData?.talent_types?.includes(item.name)),
          admin_note: jobDetailData.admin_note
        }
      }
      setFormData(detailData);

      // set schedule_public_date
      const { date: scheduleDate, hour: scheduleHour, minute: scheduleMinute } = initializeOriginalDate(detailData.public_schedule_date);
      setFormData((prev: any) => ({
        ...prev,
        public_schedule_date: scheduleDate,
        public_schedule_hour: scheduleHour,
        public_schedule_minute: scheduleMinute,
      }));
      setIsPublishReserved(detailData.is_public_scheduled);

      // set expiry_date
      const { date: deadlineDate, hour: deadlineHour, minute: deadlineMinute } = initializeOriginalDate(detailData.application_deadline);
      setFormData((prev: any) => ({
        ...prev,
        application_deadline: deadlineDate,
        application_deadline_hour: deadlineHour,
        application_deadline_minute: deadlineMinute,
      }));

      //format data
      insuranceBenefitsOptions.forEach((item: any) => {
        const field = item.name;
        item.value = detailData[field];   
      });
      setInsuranceBenefits(insuranceBenefitsOptions);

      allowancesOptions.forEach((item: any) => {
        const field = item.name;
        item.value = detailData[field];   
      });
      setAllowances(allowancesOptions);
      
      maternityLeaveOptions.forEach((item: any) => {
        const field = item.name;
        item.value = detailData[field];   
      });
      setMaternityLeave(maternityLeaveOptions);

      increaseForOverTimeOptions.forEach((item: any) => {
        const field = item.name;
        item.value = detailData[field];   
      });
      setIncreaseForOverTime(increaseForOverTimeOptions);
      
      noAgeLimitOptions.forEach((item: any) => {
        const field = item.name;
        item.value = detailData[field];
      });
      setNoAgeLimit(noAgeLimitOptions);
      
      talentTypeOptions.forEach((item: any) => {
        item.value = Array.isArray(detailData.talent_types) && 
        detailData.talent_types.includes(item.name);
      });
      setTalentType(talentTypeOptions);

      // Handle load list option: 職種, 業種
      handleReloadListOptionJobType()
      handleReloadListOptionIndustry()
    } else {
      const data = {
        ...initialData,
        company_info: company.description ? company.description : company.name,
      }
      setFormData(data);
      setInsuranceBenefits(insuranceBenefitsOptions);
      setAllowances(allowancesOptions);
      setMaternityLeave(maternityLeaveOptions);
      setIncreaseForOverTime(increaseForOverTimeOptions);
      setNoAgeLimit(noAgeLimitOptions);
      setIsPublishReserved(false);
      setTalentType(talentTypeOptions);
    }
  }, [allOptionsLoaded, jobDetailData]);

  useEffect(() => {
    if (!formData.smoking_measure && measuresAgainstPassiveSmokingOptions.length > 0) {
      setFormData((prev: any) => ({
        ...prev,
        smoking_measure: measuresAgainstPassiveSmokingOptions[0]?.value,
      }));
    }

    if (!formData.holiday_vacation && holidayAndVacationsRadioOptions.length > 0) {
      setFormData((prev: any) => ({
        ...prev,
        holiday_vacation: holidayAndVacationsRadioOptions[0]?.value,
      }));
    }

    if (formData.tag_condition == null && jobDetailData.id == null && tagLogicTypes.length > 0) {
      setFormData((prev: any) => ({
        ...prev,
        tag_condition: tagLogicTypes[0],
      }));
    }
  }, [measuresAgainstPassiveSmokingOptions, holidayAndVacationsRadioOptions, tagLogicTypes]);

  const markDirty = () => {
    if(!isFormDirty) {
      dispatch(setIsFormDirty(true));
    }
  }

  const handleChange = (e: any) => {
    markDirty();
    const { name, value } = e.target;
    setFormData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const textField = [
    { 'field': 'title', 'name': 'タイトル', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'jobType1', 'name': '職種１', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'jobType2', 'name': '職種２', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'jobType3', 'name': '職種３', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'industry1', 'name': '業種１', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'industry2', 'name': '業種２', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'industry3', 'name': '業種３', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'prefecture', 'name': '都道府県', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'work_location_notes', 'name': '勤務地変更の範囲', 'options': '', 'required': false, 'min': '', 'max': '' },
    { 'field': 'from_income', 'name': '年収', 'options': '', 'required': false, 'min': 'from_income', 'max': 'to_income' },
    { 'field': 'to_income', 'name': '年収', 'options': '', 'required': false, 'min': 'from_income', 'max': 'to_income' },
    { 'field': 'post', 'name': '役職', 'options': '', 'required': false, 'min': '', 'max': '' },
    { 'field': 'department', 'name': '部署', 'options': '', 'required': false, 'min': '', 'max': '' },
    { 'field': 'department_message', 'name': 'メッセージ', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'company_info', 'name': '企業情報', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'smoking_measure', 'name': '受動喫煙対策', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'holiday_vacation', 'name': '休日休暇', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'annual_holiday', 'name': '年間休日', 'options': '', 'required': false, 'min': '', 'max': '' },
    { 'field': 'from_working_hour', 'name': '勤務時間', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'from_working_minute', 'name': '勤務時間', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'to_working_hour', 'name': '勤務時間', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'to_working_minute', 'name': '勤務時間', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'break_time', 'name': '休憩時間', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'avg_ot_hours', 'name': '平均残業時間', 'options': '', 'required': false, 'min': '', 'max': '' },
    { 'field': 'fixed_ot_pay', 'name': '固定残業代', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'ot_pay_note', 'name': '残業代備考', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'employee_quantity', 'name': '採用人数', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'pay_type', 'name': '給与形態', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'from_monthly_fee', 'name': '月額', 'options': '', 'required': false, 'min': 'from_monthly_fee', 'max': 'to_monthly_fee' },
    { 'field': 'to_monthly_fee', 'name': '月額', 'options': '', 'required': false, 'min': 'from_monthly_fee', 'max': 'to_monthly_fee' },
    { 'field': 'salary_increase', 'name': '昇給', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'wage_remarks', 'name': '賃金備考', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'trial_period', 'name': '試用期間', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'trial_period_time', 'name': '試用期間', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'selection_process', 'name': '選考の流れ', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'job_description', 'name': '職務内容', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'scope_of_change', 'name': '変更の範囲有無', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'scope_of_change_note', 'name': '職務内容変更の範囲', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'from_age', 'name': '年齢', 'options': '', 'required': true, 'min': 'from_age', 'max': 'to_age' },
    { 'field': 'to_age', 'name': '希望年齢', 'options': '', 'required': true, 'min': 'from_age', 'max': 'to_age' },
    { 'field': 'employment_status', 'name': '雇用形態', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'working_style', 'name': '勤務形態', 'options': '', 'required': false, 'min': '', 'max': '' },
    { 'field': 'recruitment_status', 'name': '募集ステータス', 'options': '', 'required': true, 'min': '', 'max': '' },
    { 'field': 'insurance_benefits', 'name': '保険待遇', 'options': insuranceBenefits, 'required': false, 'min': '', 'max': '' },
    { 'field': 'allowances', 'name': '諸手当', 'options': allowances, 'required': false, 'min': '', 'max': '' },
    { 'field': 'tag', 'name': 'タグ', 'options': '', 'required': false, 'min': '', 'max': '' },
    { 'field': 'public_schedule_date', 'name': '', 'options': '', 'required': false, 'min': '', 'max': '' },
    { 'field': 'public_schedule_hour', 'name': '', 'options': '', 'required': false, 'min': '', 'max': '' },
    { 'field': 'public_schedule_minute', 'name': '', 'options': '', 'required': false, 'min': '', 'max': '' },
    { 'field': 'application_deadline', 'name': '', 'options': '', 'required': false, 'min': '', 'max': '' },
    { 'field': 'application_deadline_hour', 'name': '', 'options': '', 'required': false, 'min': '', 'max': '' },
    { 'field': 'application_deadline_minute', 'name': '', 'options': '', 'required': false, 'min': '', 'max': '' },
    { 'field': 'talent_type', 'name': 'タレントの種別', 'options': talentType, 'required': true, 'min': '', 'max': '' },
  ]; 

  const publicTimeErrorMsg = i18n.t('MSG_GLOBAL_PUBLISH_SCHEDULE_MIN_ONE_HOUR');

  const validateField: any = {};
  textField.forEach((item: any) => { validateField[item.field] = ""; });
  const [formErrors, setFormErrors]: any = useState(validateField);

  let formErrorsTmp: any = {};
  textField.forEach((item) => { formErrorsTmp[item.field] = ""; });

  const validateSchedulePost = (formData: any): { hasError: boolean; errorState: ErrorState } => {
    let hasError = false;
    let errorState: ErrorState = {};

    if (!formData.public_schedule_date) {
      hasError = true;
      errorState.public_schedule_date = i18n.t('MSG_GLOBAL_PUBLISH_SCHEDULE_DATE_REQUIRED');
    }
    if (formData.public_schedule_hour || formData.public_schedule_minute) {
      if(formData.public_schedule_hour < 0 || formData.public_schedule_hour > 23) {
        hasError = true;
        errorState.public_schedule_hour = i18n.t('MSG_GLOBAL_HOUR_MINUTE_RANGE');
      }
      if(formData.public_schedule_minute < 0 || formData.public_schedule_minute > 59) {
        hasError = true;
        errorState.public_schedule_minute = i18n.t('MSG_GLOBAL_HOUR_MINUTE_RANGE');
      }
    }
    if(!formData.public_schedule_hour) {
      hasError = true;
      errorState.public_schedule_hour = i18n.t('MSG_GLOBAL_HOUR_REQUIRED');
    }
    if (!formData.public_schedule_minute) {
      hasError = true;
      errorState.public_schedule_minute = i18n.t('MSG_GLOBAL_MINUTE_REQUIRED');
    }
    if (formData.public_schedule_date && formData.public_schedule_hour && formData.public_schedule_minute) {
      const scheduled = getDateOverTime(formData.public_schedule_date, formData.public_schedule_hour, formData.public_schedule_minute);
      const nowPlus1Hour = getMinPublicTime();

      if (scheduled < nowPlus1Hour) {
        hasError = true;
        errorState.public_schedule_date = errorState.public_schedule_hour = errorState.public_schedule_minute = publicTimeErrorMsg;
      }
    }

    return { hasError, errorState };
  };

  const validateApplicationDeadline = (formData: any): { hasError: boolean; errorState: ErrorState } => {
    let hasError = false;
    let errorState: ErrorState = {};

    if(!formData.application_deadline) {
      setFormData((prev: any) => ({
        ...prev,
        application_deadline_hour: null,
        application_deadline_minute: null
      }));
      return { hasError, errorState };
    }

    if (formData.application_deadline_hour || formData.application_deadline_minute) {
      if(formData.application_deadline_hour < 0 || formData.application_deadline_hour > 23) {
        hasError = true;
        errorState.application_deadline_hour = i18n.t('MSG_GLOBAL_HOUR_MINUTE_RANGE');
      }
      if(formData.application_deadline_minute < 0 || formData.application_deadline_minute > 59) {
        hasError = true;
        errorState.application_deadline_minute = i18n.t('MSG_GLOBAL_HOUR_MINUTE_RANGE');
      }
    }
    if(!formData.application_deadline_hour) {
      hasError = true;
      errorState.application_deadline_hour = i18n.t('MSG_GLOBAL_HOUR_REQUIRED');
    }
    if (!formData.application_deadline_minute) {
      hasError = true;
      errorState.application_deadline_minute = i18n.t('MSG_GLOBAL_MINUTE_REQUIRED');
    }
    
    const expired = getDateOverTime(formData.application_deadline, formData.application_deadline_hour, formData.application_deadline_minute);

    let scheduled = new Date();
    if (formData.is_public_scheduled && formData.public_schedule_date) {
      scheduled = getDateOverTime(formData.public_schedule_date, formData.public_schedule_hour, formData.public_schedule_minute);
    }

    if (expired <= scheduled) {
      hasError = true;
      errorState.application_deadline = errorState.application_deadline_hour = errorState.application_deadline_minute = i18n.t('MSG_JOB_APPLICATION_END_DATE_AFTER_PUBLISH_DATE');
    }
    return { hasError, errorState };
  }

  const validateWorkingTime = (formData: any): { hasError: boolean; errorState: ErrorState } => {
    let hasError = false;
    let errorState: ErrorState = {};

    if (formData.from_working_hour || formData.from_working_minute || formData.to_working_hour || formData.to_working_minute) {
      if(formData.from_working_hour < 0 || formData.from_working_hour > 23) {
        hasError = true;
        errorState.from_working_hour = i18n.t('MSG_GLOBAL_HOUR_MINUTE_RANGE');
      }
      if(formData.from_working_minute < 0 || formData.from_working_minute > 59) {
        hasError = true;
        errorState.from_working_minute = i18n.t('MSG_GLOBAL_HOUR_MINUTE_RANGE');
      }
      if(formData.to_working_hour < 0 || formData.to_working_hour > 23) {
        hasError = true;
        errorState.to_working_hour = i18n.t('MSG_GLOBAL_HOUR_MINUTE_RANGE');
      }
      if(formData.to_working_minute < 0 || formData.to_working_minute > 59) {
        hasError = true;
        errorState.to_working_minute = i18n.t('MSG_GLOBAL_HOUR_MINUTE_RANGE');
      }
    }
    if (formData.from_working_hour && formData.from_working_minute && formData.to_working_hour && formData.to_working_minute) {
      if(formData.from_working_hour == formData.to_working_hour && formData.from_working_minute == formData.to_working_minute) {
        hasError = true;
        errorState.from_working_hour = errorState.from_working_minute = errorState.to_working_hour =  errorState.to_working_minute = i18n.t('MSG_SAME_WORKING_HOUR_START_END');
      }
    }
    if(!formData.from_working_hour) {
      hasError = true;
      errorState.from_working_hour = '勤務時間は必須です。';
    }
    if (!formData.from_working_minute) {
      hasError = true;
      errorState.from_working_minute = '勤務時間は必須です。';
    }
    if(!formData.to_working_hour) {
      hasError = true;
      errorState.to_working_hour = '勤務時間は必須です。';
    }
    if (!formData.to_working_minute) {
      hasError = true;
      errorState.to_working_minute = '勤務時間は必須です。';
    }

    return { hasError, errorState };
  };

  const validateFormData = () => {
    const validRequiredField: any = [];
    const validRequiredOptionsField: any = [];
    textField.forEach((item: any) => {
      if(item.required && !['from_working_hour', 'from_working_minute', 'to_working_hour', 'to_working_minute'].includes(item.field)){
        if(!item.options){
          validRequiredField.push(item.field);
        }
        else{
          validRequiredOptionsField.push(item.field);
        }
      }
      if(item.field == 'from_age' || item.field == 'to_age'){
        if(!formData['has_no_age_limit']){
          validRequiredField.push(item.field);
        }
        else{
          const index = validRequiredField.indexOf(item.field);
          if (index !== -1) {
              validRequiredField.splice(index, 1);
          }
        }
      }
      if(item.field == 'trial_period_time'){
        if(formData['trial_period']) {
          validRequiredField.push(item.field);
          if(formData['trial_period_time'] && (formData['trial_period_time'] < 1 || formData['trial_period_time'] > 12)) {
            formErrorsTmp['trial_period_time'] = i18n.t('MSG_COMPANY_JOB_VALIDATION_PROBATION_MONTHS');
          }
        } else{
          const index = validRequiredField.indexOf(item.field);
          if (index !== -1) {
              validRequiredField.splice(index, 1);
          }
        }
      }
      if(item.field == 'scope_of_change_note'){
        if(formData['scope_of_change']) validRequiredField.push(item.field);
        else{
          const index = validRequiredField.indexOf(item.field);
          if (index !== -1) {
              validRequiredField.splice(index, 1);
          }
        }
      }
      if(item.field == 'ot_pay_note'){
        if(formData['fixed_ot_pay']) validRequiredField.push(item.field);
        else{
          const index = validRequiredField.indexOf(item.field);
          if (index !== -1) {
              validRequiredField.splice(index, 1);
          }
        }
      }
      if(item.field == 'wage_remarks'){
        if(formData['salary_increase']) validRequiredField.push(item.field);
        else{
          const index = validRequiredField.indexOf(item.field);
          if (index !== -1) {
              validRequiredField.splice(index, 1);
          }
        }
      }
      if(item.min != "" && item.max != ""){
        const minValue = formData[item.min];
        const maxValue = formData[item.max];
        if(minValue && maxValue && minValue >= maxValue) formErrorsTmp[item.field] = i18n.t('MSG_JOB_VALIDATION_MIN_MAX_VALUES');
      }
      if(item.field == 'tag'){
        if (!isValidTagString(formData[item.field])) {
          formErrorsTmp[item.field] = i18n.t('MSG_GLOBAL_TAG_SEPARATOR_INVALID');
        } 
      }
      
      if(item.field.includes('from_working_hour', 'from_working_minute', 'to_working_hour', 'to_working_minute')){
        const { hasError, errorState } = validateWorkingTime(formData);

        if (hasError) {
          formErrorsTmp = { ...formErrorsTmp, ...errorState };
        }
      }
      
      if (isPublishReserved) {
        const { hasError, errorState } = validateSchedulePost(formData);

        if (hasError) {
          formErrorsTmp = { ...formErrorsTmp, ...errorState };
        }
      }

      if (item.field.includes('application_deadline', 'application_deadline_hour', 'application_deadline_minute')) {
        const { hasError, errorState } = validateApplicationDeadline(formData);

        if (hasError) {
          formErrorsTmp = { ...formErrorsTmp, ...errorState };
        }
      }
    });
    validRequiredField.forEach((field: any) => {
      const text = textField.find((item) => item.field === field);
      if (text) {
        const valid = validateRequired(formData[field], text.name);
        if (valid !== true) {
          formErrorsTmp[field] = valid;
        }
      }
    });
    validRequiredOptionsField.forEach((field: any) => {
      const text = textField.find((item) => item.field === field);
      if (text) {
        const valid = validateOptionsRequired(text.options, text.name, text.field);
        if (valid !== true) {
          formErrorsTmp[field] = valid;
        }
      }
    });

    setFormErrors(formErrorsTmp);
    return !Object.values(formErrorsTmp).some((error) => error);
  };

  const handleChangeTime = (name: string, value: string | number) => {
    markDirty();
    setFormData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeNumber = (e: any) => {
    markDirty();
    const { name, value, min, max, maxLength } = e.target;
    let numericValue: any = parseInt(value, 10);

    // reset fields if selected no_age_limit
    if (['from_age', 'to_age'].some(item => name.includes(item)) && (noAgeLimit && noAgeLimit[0].value)) {
      setFormData((prev: any) => ({ ...prev, [name]: "" }));
      return;
    }
    
    // Validate against min and max
    if (!isNaN(numericValue) && /^[0-9]+$/.test(numericValue)) {
      numericValue = String(numericValue).slice(0, maxLength);
      const minValue = parseInt(min, 10);
      const maxValue = parseInt(max, 10);
      numericValue = parseInt(numericValue);
      if (numericValue < minValue) numericValue = minValue;
      if (numericValue > maxValue) numericValue = maxValue;
    } else {
      numericValue = "" // Allow clearing the input
    }

    setFormData((prev: any) => ({ ...prev, [name]: numericValue })); // Value stored as string
  };

  const handleSetExpiryDate = (dateInput: any) => {
    const dateString = dateToString(dateInput);
    setFormData((prev: any) => ({ ...prev, application_deadline: dateString, }));
  }

  const getDateOverTime = (date, hour, minute): any => {
    const dateOverTime = new Date(date);
    dateOverTime.setHours(hour);
    dateOverTime.setMinutes(minute);
    dateOverTime.setSeconds(0);
    dateOverTime.setMilliseconds(0);
    return dateOverTime;
  }

  const handleSubmit = (e: any, is_navigate: boolean) => {
    e.preventDefault();
    noAgeLimit.map(({name, value}: any) => { formData[name] = value; });
    
    if (!validateFormData()) {
      // Scroll to first error
      setTimeout(() => {
        const firstError = document.querySelector("p.alu-text-error");
        if (firstError) {
          firstError.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 200);
      return;
    } else {
      allowances.map(({name, value}: any) => { formData[name] = value; });
      insuranceBenefits.map(({name, value}: any) => { formData[name] = value; });
      increaseForOverTime.map(({name, value}: any) => { formData[name] = value; });
      maternityLeave.map(({name, value}: any) => { formData[name] = value; });

      let talentTypeNames = talentType.filter(item => item.value).map((item) => (item.name));
      formData.talent_types = talentTypeNames.join(",");
      formData.tags = formData?.tags ? formData?.tags?.map(item => item.id).join(",") : ''

      if(jobDetailData.id){
        delete formData.is_public;

        // get schedule_public_date
        let scheduleDate = formData.public_schedule_date || null;
        if (formData.public_schedule_date) {
          const localDate = getDateOverTime(formData.public_schedule_date, formData.public_schedule_hour, formData.public_schedule_minute);
          scheduleDate = localDate.toISOString();
          formData.public_schedule_date_history = dayjs(localDate).format('YYYY-MM-DD HH:mm');
        }
        formData.is_public_scheduled = isPublishReserved;
        formData.public_schedule_date = scheduleDate;

        // get expiry_date
        let applicationDeadline = formData.application_deadline || null;
        if (formData.application_deadline) {
          const localDate = getDateOverTime(formData.application_deadline, formData.application_deadline_hour, formData.application_deadline_minute);
          applicationDeadline = localDate.toISOString();
          formData.expiry_date_history = dayjs(localDate).format('YYYY-MM-DD HH:mm');
        }
        formData.expiry_date = formData.application_deadline = applicationDeadline;
        
        const data = {
          id: jobDetailData.id,
          requestBody: { ...formData, }
        }
        if(is_navigate){
          dispatch(setJobDetailDataTemp(formData));
          if(isFormDirty) {
            dispatch(setIsChangeBeforePreview(true));
          }
        } else {
          dispatch(setJobDetailDataTemp(null));
          dispatch(updateJobDetail(data));

          dispatch(setIsFormDirty(false));
          dispatch(setShowLeaveConfirm(false));
        }
        
        handleGotoPage('edit', is_navigate);
      } else {
        // get schedule_public_date
        let scheduleDate = formData.public_schedule_date || null;
        if (formData.public_schedule_date) {
          const localDate = getDateOverTime(formData.public_schedule_date, formData.public_schedule_hour, formData.public_schedule_minute);
          scheduleDate = localDate.toISOString();
        }

        // get expiry_date
        let applicationDeadline = formData.application_deadline || null;
        if (formData.application_deadline) {
          const localDate = getDateOverTime(formData.application_deadline, formData.application_deadline_hour, formData.application_deadline_minute);
          applicationDeadline = localDate.toISOString();
        }

        const data = {
          requestBody: {
            ...formData,
            is_public_scheduled: isPublishReserved,
            public_schedule_date: scheduleDate,
            application_deadline: applicationDeadline,
          }
        }
        dispatch(setJobDetailDataTemp(null));
        dispatch(createJob(data));
        dispatch(setIsChangeBeforePreview(true));
        handleGotoPage('create', is_navigate);
      }
    }
  };

  const handleGotoPage = (currentPage: string, is_navigate: boolean) => {
    if(currentPage == "edit" && is_navigate && jobDetailData.id){
      navigate("/company/job/preview/" + jobDetailData.id);
      return;  
    }
    if(currentPage == "create"){
      if(is_navigate){
        dispatch(setIsNavigateToPreview(true));
      } else {
        dispatch(setIsNavigateToEdit(true));
      }
      return;
    }    
  }

  const handleChangeRecruitmentStatus = (option): any => {
    markDirty();
    setFormData((prev: any) => ({ ...prev, recruitment_status: option, }))

    if (option.value == RECRUITMENT_STATUS.PRIVATE) {
      setIsPublishReserved(false);
    }
  }

  useEffect(() => {
    if(jobDetailData.id > 0 && isNavigateToPreview){
      dispatch(setError(null));
      dispatch(setSuccess(null));
      navigate("/company/job/preview/" + jobDetailData.id);
      dispatch(setIsNavigateToPreview(false));
    }
    else if(jobDetailData.id > 0 && isNavigateToEdit){
      navigate("/company/job/edit/" + jobDetailData.id)
      dispatch(setIsNavigateToEdit(false));
    }    
  }, [jobDetailData, isNavigateToPreview, isNavigateToEdit])

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const showCustomToast = ({title="メッセージ", message, variant="success", type="normal"}) => {
    enqueueSnackbar("I love snacks.", {
      content: (key) => (
        <CustomToast title={title} message={message} variant={variant} snackbarKey={key} closeSnackbar={closeSnackbar} type={type}/>
      ),
    });
  }
  useEffect(() => {
    if(actionName == "createJob" || actionName == "updateJobDetail"){
      if(error) {
        showCustomToast({message: error, variant: "error"});
        dispatch(setError(null));
      }
      else if(success && !isNavigateToPreview) {
        showCustomToast({message: success});
        dispatch(setSuccess(null));
      }
    }
  }, [error, success]);

  const handleChangeNoAgeLimit = (noAge, idx) => {
    markDirty();
    const newList = noAgeLimit.map((item, index) =>
      idx === index ? { ...item, value: !item.value } : { ...item }
    );
    setNoAgeLimit(newList);
    setFormData((prev: any) => ({
      ...prev,
      from_age: newList && newList[0]?.value ? "" : prev.from_age,
      to_age: newList && newList[0]?.value ? "" : prev.to_age,
      applicant_age_min: newList && newList[0]?.value ? "" : prev.from_age,
      applicant_age_max: newList && newList[0]?.value ? "" : prev.to_age,
    }));
  }

  const handleSwitchPublished = (e) => {
    setIsPublishReserved(e.target.checked);
    setFormData((prev: any) => ({ ...prev, is_public_scheduled: e.target.checked, }));
  }

  const handleChangeJobTypeLevel1 = (value) => {
    markDirty();
    setFormData((prev: any) => ({
      ...prev,
      jobType1: value,
      jobType2: null,
      jobType3: null,
    }));

    // Reload options level 2
    if (value && value.code) {
      setJobType2Options(jobTypeOptions.filter(item => item.parent_id == value.code && item.level == 2))
    } else {
      setJobType2Options([])
    }

    // Reload options level 3
    setJobType3Options([])

    // Forcus to 職種２
    jobType2DropdownRef.current?.focus();
  }

  const handleChangeJobTypeLevel2 = (value) => {
    setFormData((prev: any) => ({ ...prev, jobType2: value, jobType3: null,}));

    // Reload options level 3
    if (value && value.code) {
      setJobType3Options(jobTypeOptions.filter(item => item.parent_id == value.code && item.level == 3))
    } else {
      setJobType3Options([])
    }

    // Forcus to 職種3
    jobType3DropdownRef.current?.focus();
  }

  const handleChangeIndustryLevel1 = (value) => {
    markDirty();
    setFormData((prev: any) => ({ ...prev, industry1: value, industry2: null, industry3: null, }));

    // Reload options level 2
    if (value && value.code) {
      setIndustry2Options(industryOptions.filter(item => item.parent_id == value.code && item.level == 2))
    } else {
      setIndustry2Options([])
    }

    // Reload options level 3
    setIndustry3Options([])

    // Forcus to 業種２
    industry2DropdownRef.current?.focus();
  }

  const handleChangeIndustryLevel2 = (value) => {
    setFormData((prev: any) => ({ ...prev, industry2: value, industry3: null, }));

    // Reload options level 3
    if (value && value.code) {
      setIndustry3Options(industryOptions.filter(item => item.parent_id == value.code && item.level == 3))
    } else {
      setIndustry3Options([])
    }

    // Forcus to 業種3
    industry3DropdownRef.current?.focus();
  }

  const handleReloadListOptionJobType = () => {
    if(!jobTypeOptions || jobTypeOptions.length == 0 || !jobDetailData) {
      return
    }
    if(jobDetailData.occupation_1) {
      setJobType2Options(jobTypeOptions.filter(item => item.parent_id == jobDetailData.occupation_1.code && item.level == 2))
    }
    if(jobDetailData.occupation_2) {
      setJobType3Options(jobTypeOptions.filter(item => item.parent_id == jobDetailData.occupation_2.code && item.level == 3))
    }
  }

  const handleReloadListOptionIndustry = () => {
    if(!industryOptions || industryOptions.length == 0 || !jobDetailData) {
      return
    }
    if(jobDetailData.industry_1) {
      setIndustry2Options(industryOptions.filter(item => item.parent_id == jobDetailData.industry_1.code && item.level == 2))
    }
    if(jobDetailData.industry_2) {
      setIndustry3Options(industryOptions.filter(item => item.parent_id == jobDetailData.industry_2.code && item.level == 3))
    }
  }

  //Access to this page is denied
  if (checkingAccess) {
    return null;
  }
  if ((!id && !staffPermission[PERMISSIONS.JOB_NEW]) ||
      (id && !staffPermission[PERMISSIONS.JOB_EDIT]) ||
      (id && !jobDetailData.id)) {
    return <NotFoundPage />;
  }

  const handleNavigateBack = () => {
    if(isFormDirty) {
      dispatch(setShowLeaveConfirm(true));
    } else {
      navigate('/company/job', { state: { isFromDetail: true } });
    }
  }

  const handleCloseLeavePageConfirm = () => {
    setIsLeavePage(false);
  }

  const handleGoToTagList = () => {
    if(isFormDirty) {
      setIsLeavePage(true)
      setUrlLeave('/company/talent/tags')
    } else {
      dispatch(setIsOpenSearchTagsPanel(false)); 
      navigate('/company/talent/tags')
    }
  };

  const handleCancelChange = () => {
    dispatch(setJobDetailDataTemp(null));
    dispatch(setJobDetailData([]));
    navigate('/company/job', { state: { isFromDetail: true } });
  }

  const scheduleErrorMsg = getTimeErrorMessage(formErrors.public_schedule_date, formErrors.public_schedule_hour, formErrors.public_schedule_minute, null, null);
  const applicationDeadlineErrorMsg = getTimeErrorMessage(formErrors.application_deadline, formErrors.application_deadline_hour, formErrors.application_deadline_minute, null, null);
  const workingHourErrorMsg = getTimeErrorMessage(null, formErrors.from_working_hour, formErrors.from_working_minute, formErrors.to_working_hour, formErrors.to_working_minute);

  return (
    <>
      <CompanyHeader />
      <div className="mt-6 px-6 flex gap-6 relative">
        <CompanySideMenu />
        <div className="flex-1">
          <div className="mb-6 flex items-center gap-4">
            <ReturnButton onClick={handleNavigateBack} />
            <span className="text-sm alu-text-base-1">/</span>
            <h3 className="text-xl leading-[1.875rem] alu-text-base-2 font-bold">
              {id ? "求人の編集" : "求人の新規追加"}
            </h3>
          </div>

          <div className="bg-white rounded-2xl p-6 alu-section-box-shadow">
            <form className="w-full">
              <div className="w-full">
                <div className="flex items-center gap-[0.375rem] py-2 mb-6">
                  <CustomTag type="optional" />
                  <p className="text-xs alu-text-base-1">··· 正社員等の求人票や募集要項で、労働条件として明示が必要な項目です。</p>
                </div>
                {/* #1 タイトル */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center gap-2 mb-2">
                      <label className="text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="title">
                        タイトル
                      </label>
                      <CustomTag type="required" />
                    </div>
                    <TextInput
                      customClassName="!h-[45px]"
                      maxLength={100}
                      id="title"
                      name="title"
                      value={formData.title}
                      onChange={handleChange}
                      placeholder="入力してください"
                      error={formErrors.title}
                      errorText={formErrors.title}
                      tabindex={1}
                    />
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #2 タレントの種別 */}
                <div className={`mb-6 gap-6 flex items-center`}>
                  <div className="w-[75%] flex items-start relative">
                    <div className="min-w-[10.875rem] flex items-center gap-2 mt-2">
                      <label className="text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="allowance">
                        タレントの種別
                      </label>
                      <CustomTag type="required" />
                    </div>
                    <div>
                      <div className="w-full flex flex-wrap gap-x-6 gap-y-2">
                        {talentType.map((itemType, idx) => (
                          <div key={idx} className="w-[144px]">
                            <CheckboxButton
                              name={itemType.name}
                              label={itemType.label}
                              value={itemType.value}
                              tabindex={2}
                              onChange={() => {
                                markDirty();
                                const newList = talentType.map((item, index) => idx === index
                                    ? { ...item, value: !item.value } : { ...item }
                                );
                                setTalentType(newList);
                              }}
                            />
                          </div>
                        ))}
                      </div>
                      {formErrors.talent_type && (
                        <p className="alu-text-error text-sm mt-2">
                          *{formErrors.talent_type}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="w-[25%]">
                    <p className="text-xs alu-text-base-1">選択した種別のタレントに求人情報を表示します。</p>
                  </div>
                </div>

                {/* #3 タレントタグ */}
                <div className="mb-6 gap-6 flex items-center">
                  <div className='w-[75%] flex items-start'>
                    <label className="min-w-[10.875rem] block shrink-0 text-sm mb-2 alu-text-base-2 font-bold mt-2">タレントタグ</label>
                    <div className="flex-1 flex items-start flex-wrap gap-3">
                      {/* tags */}
                      <div className='flex-1'>
                        <Dropdown
                          clearable={true}
                          inputWidth="full"
                          options={talentTagOptions}
                          placeholder=""
                          value={formData?.tags}
                          onChange={(value: any) => {
                            markDirty();
                            setFormData((prev) => ({ ...prev, tags: value }))
                          }}
                          multiple={true}
                          havingIcon={false}
                          searchInput={true}
                          searchQuery={searchTagQuery}
                          setSearchQuery={setSearchTagQuery}
                          customStyle='!max-h-full'
                          isMinHeight={true}
                          isValuesTruncated={false}
                          noOptionsFoundText={searchTagQuery ? '指定した条件のタグは見つかりませんでした' : 'タグが登録されていません'}
                          optionStyles='px-2 py-[0.125rem] rounded-sm bg-[#F7F7F7] text-center'
                          actionsButton={[{ name: 'タグ管理', variant: 'outline', handleClick: () => handleGoToTagList()}]}
                          tabindex={3}
                        />
                      </div>
                      <div className='w-[96px] shrink-0'>
                        <Dropdown
                          inputWidth="full"
                          options={tagLogicTypes}
                          placeholder=""
                          value={formData.tag_condition}
                          onChange={(value: any) => {
                            setFormData((prev) => ({ ...prev, tag_condition: value }));
                            markDirty();
                          }}
                          tabindex={4}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="w-[25%]">
                    <p className="text-xs alu-text-base-1">選択したタレントタグのタレントに求人情報を表示します。</p>
                  </div>
                </div>

                {/* #4 職種 */}
                <div className="mb-6 flex gap-6">
                  <div className="w-[75%] flex items-start gap-6">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="type1">
                          職種１
                        </label>
                        <CustomTag type="required" />
                      </div>
                      <div className="w-full">
                        <Dropdown
                          inputWidth="full"
                          placeholder={"選択してください"}
                          options={jobType1Options}
                          value={formData.jobType1}
                          onChange={(value: any) => handleChangeJobTypeLevel1(value)}
                          customStyle={`${formErrors.jobType1 && "border-2 border-[#F33D62] hover:border-[#F33D62] hover:bg-[#FFF3E5] cursor-pointer"}`}
                          tabindex={5}
                        />
                        {formErrors.jobType1 && <p className="alu-text-error text-sm mt-2">*{formErrors.jobType1}</p>}
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="type2">
                          職種２
                        </label>
                        <CustomTag type="required" />
                      </div>
                      <div className="w-full">
                        <Dropdown
                          inputWidth="full"
                          dropdownRef={jobType2DropdownRef}
                          disabled={!formData.jobType1}
                          placeholder={"選択してください"}
                          options={jobType2Options}
                          value={formData.jobType2}
                          onChange={(value: any) => {markDirty(); handleChangeJobTypeLevel2(value)}}
                          customStyle={`${formErrors.jobType2 && "border-2 border-[#F33D62] hover:border-[#F33D62] hover:bg-[#FFF3E5] cursor-pointer"}`}
                          tabindex={6}
                        />
                        {formErrors.jobType2 && <p className="alu-text-error text-sm mt-2">*{formErrors.jobType2}</p>}
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="type3">
                          職種３
                        </label>
                        <CustomTag type="required" />
                      </div>
                      
                      <div className="w-full">
                        <Dropdown
                          inputWidth="full"
                          dropdownRef={jobType3DropdownRef}
                          disabled={!formData.jobType2}
                          placeholder={"選択してください"}
                          options={jobType3Options}
                          value={formData.jobType3}
                          onChange={(value: any) => { 
                              markDirty();
                              setFormData((prev: any) => ({...prev, jobType3: value,}));
                              industry1DropdownRef.current?.focus();
                            }
                          }
                          customStyle={`${formErrors.jobType3 && "border-2 border-[#F33D62] hover:border-[#F33D62] hover:bg-[#FFF3E5] cursor-pointer"}`}
                          tabindex={7}
                        />
                        {formErrors.jobType3 && <p className="alu-text-error text-sm mt-2">*{formErrors.jobType3}</p>}
                      </div>
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #5 業種 */}
                <div className="mb-6 flex gap-6">
                  <div className="w-[75%] flex items-start gap-6">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="industry1">
                          業種１
                        </label>
                        <CustomTag type="required" />
                      </div>
                      <div className="w-full">
                        <Dropdown
                          inputWidth="full"
                          dropdownRef={industry1DropdownRef}
                          placeholder={"選択してください"}
                          options={industry1Options}
                          value={formData.industry1}
                          onChange={(value: any) => handleChangeIndustryLevel1(value)}
                          customStyle={`${formErrors.industry1 && "border-2 border-[#F33D62] hover:border-[#F33D62] hover:bg-[#FFF3E5] cursor-pointer"}`}
                          tabindex={8}
                        />
                        {formErrors.industry1 && <p className="alu-text-error text-sm mt-2">*{formErrors.industry1}</p>}
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="industry2">
                          業種２
                        </label>
                        <CustomTag type="required" />
                      </div>
                      <div className="w-full">
                        <Dropdown
                          inputWidth="full"
                          dropdownRef={industry2DropdownRef}
                          disabled={!formData.industry1}
                          placeholder={"選択してください"}
                          options={industry2Options}
                          value={formData.industry2}
                          onChange={(value: any) => {markDirty(); handleChangeIndustryLevel2(value)}}
                          customStyle={`${formErrors.industry2 && "border-2 border-[#F33D62] hover:border-[#F33D62] hover:bg-[#FFF3E5] cursor-pointer"}`}
                          tabindex={9}
                        />
                        {formErrors.industry2 && <p className="alu-text-error text-sm mt-2">*{formErrors.industry2}</p>}
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="industry3">
                          業種３
                        </label>
                        <CustomTag type="required" />
                      </div>
                      <div className="w-full">
                        <Dropdown
                          inputWidth="full"
                          dropdownRef={industry3DropdownRef}
                          disabled={!formData.industry2}
                          placeholder={"選択してください"}
                          options={industry3Options}
                          value={formData.industry3}
                          onChange={(value: any) => {
                            markDirty();
                            setFormData((prev: any) => ({
                              ...prev,
                              industry3: value,
                            }))}
                          }
                          customStyle={`${formErrors.industry3 && "border-2 border-[#F33D62] hover:border-[#F33D62] hover:bg-[#FFF3E5] cursor-pointer"}`}
                          tabindex={10}
                        />
                        {formErrors.industry3 && <p className="alu-text-error text-sm mt-2">*{formErrors.industry3}</p>}
                      </div>
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #6 勤務地 */}
                <div className="mb-6 gap-6 flex">
                  <div className="flex justify-between w-[75%]">
                    <label className="block shrink-0 min-w-[5.5rem] text-sm font-bold alu-text-base-2 pointer-events-none" htmlFor="location">
                      勤務地
                    </label>
                    <div className="flex-1 flex flex-col gap-4">
                      <div>
                        <div className="flex items-center gap-2 mb-2">
                          <label className="block text-sm leading-none font-normal alu-text-base-2 pointer-events-none" htmlFor="prefecture">
                            都道府県
                          </label>
                          <CustomTag type="required" />
                        </div>
                        <Dropdown
                          customStyle="min-w-[13rem]"
                          error={formErrors.prefecture}
                          errorText={formErrors.prefecture}
                          placeholder={"選択してください"}
                          options={prefectures}
                          value={formData.prefecture}
                          onChange={(value: any) => {
                            markDirty();
                            setFormData((prev: any) => ({...prev, prefecture: value,}));
                            if (formData.smoking_measure === "no_solution" && prefectures.some((pref: any) => pref.id === value.id))
                              setFormData((prev: any) => ({...prev, smoking_measure: null, }));
                          }}
                          tabindex={11}
                        />
                      </div>
                      <div>
                        <label className="block mb-2 text-sm font-normal alu-text-base-2 pointer-events-none" htmlFor="municipalities">
                          市区町村
                        </label>
                        <TextInput
                          customClassName="!h-[45px]"
                          maxLength={100}
                          id="municipalities"
                          name="municipalities"
                          value={formData.municipalities}
                          onChange={handleChange}
                          placeholder="入力してください"
                          error={formErrors.municipalities}
                          errorText={formErrors.municipalities}
                          tabindex={12}
                        />
                      </div>
                      <div>
                        <label className="block mb-2 text-sm font-normal alu-text-base-2 pointer-events-none" htmlFor="street_address">
                          番地・ビル名
                        </label>
                        <TextInput
                          customClassName="!h-[45px]"
                          maxLength={100}
                          id="street_address"
                          name="street_address"
                          value={formData.street_address}
                          onChange={handleChange}
                          placeholder="入力してください"
                          error={formErrors.street_address}
                          errorText={formErrors.street_address}
                          tabindex={13}
                        />
                      </div>
                      <div>
                        <label className="block mb-2 text-sm font-normal alu-text-base-2 pointer-events-none" htmlFor="nearest_station">
                          最寄り駅
                        </label>
                        <TextInput
                          customClassName="!h-[45px]"
                          maxLength={100}
                          id="nearest_station"
                          name="nearest_station"
                          value={formData.nearest_station}
                          onChange={handleChange}
                          placeholder="入力してください"
                          error={formErrors.nearest_station}
                          errorText={formErrors.nearest_station}
                          tabindex={14}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #7 勤務地変更の範囲 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center gap-2 mb-2">
                      <label className="block text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="work_location_notes">
                        勤務地変更の範囲
                      </label>
                      <CustomTag type="optional" />
                    </div>
                    <CustomTextarea
                      error={formErrors.work_location_notes}
                      errorText={formErrors.work_location_notes}
                      rows={3}
                      maxLength={400}
                      id="work_location_notes"
                      name="work_location_notes"
                      value={formData.work_location_notes}
                      tabindex={15}
                      onChange={(e: any) => {
                        markDirty();
                        const value = e.target.value;
                        setFormData((prev: any) => ({ ...prev, work_location_notes: value,}));
                        if (!["学校", "官庁", "病院"].includes(value) && ["no_smoking_premise","smoking_area_avai",].includes(formData.smoking_measure))
                          setFormData((prev: any) => ({...prev, smoking_measure: null,}));
                      }}
                      placeholder="入力してください"
                    />
                  </div>
                  <div className="w-[25%]">
                    <p className="text-xs alu-text-base-1 mt-[27px]">正社員等の求人票や募集要項で、労働条件として明示が必要な項目です。</p>
                  </div>
                </div>

                {/* #8 職務内容 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center gap-2 mb-2">
                      <label className="block text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="job_description">
                        職務内容
                      </label>
                      <CustomTag type="required" />
                    </div>
                    <CustomTextarea
                      required={true}
                      rows={5}
                      maxLength={2000}
                      id="job_description"
                      name="job_description"
                      value={formData.job_description}
                      onChange={handleChange}
                      placeholder="入力してください"
                      error={formErrors.job_description}
                      errorText={formErrors.job_description}
                      tabindex={16}
                    />
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #9 部署 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-start">
                    <div className="min-w-[10.875rem] flex items-center gap-2 mt-[13px]">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="department">
                        部署
                      </label>
                      <CustomTag type="optional" />
                    </div>
                    <div className="w-full">
                      <TextInput
                        customClassName="!h-[45px]"
                        maxLength={100}
                        required={true}
                        id="department"
                        name="department"
                        value={formData.department}
                        onChange={handleChange}
                        placeholder="入力してください"
                        error={formErrors.department}
                        errorText={formErrors.department}
                        tabindex={17}
                      />
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #10 変更の範囲有無 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-center">
                    <div className="min-w-[10.875rem] flex items-center gap-2">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="scope_of_change">
                        変更の範囲有無
                      </label>
                      <CustomTag type="required" />
                    </div>
                    <div className="flex-1">
                      <RadioGroup
                        name={"scope_of_change"}
                        options={[{ label: "有", value: true }, { label: "無", value: false },]}
                        value={formData.scope_of_change}
                        onChange={(value: any) => {
                          markDirty();
                          setFormData((prev: any) => ({...prev, scope_of_change: value,}));
                        }}
                        error={formErrors.scope_of_change}
                        errorText={formErrors.scope_of_change}
                        tabindex={18}
                      />
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #11 変更の範囲 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center gap-2 mb-2">
                      <label className="block text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="scope_of_change_note">
                        職務内容変更の範囲
                      </label>
                    </div>
                    <CustomTextarea
                      required={formData.scope_of_change}
                      rows={5}
                      maxLength={2000}
                      id="scope_of_change_note"
                      name="scope_of_change_note"
                      value={formData.scope_of_change_note}
                      onChange={handleChange}
                      placeholder="入力してください"
                      tabindex={19}
                      disabled={!formData.scope_of_change}
                      error={formErrors.scope_of_change_note}
                      errorText={formErrors.scope_of_change_note}
                    />
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #12 役職 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-start">
                    <div className="min-w-[10.875rem] flex items-center gap-2 mt-2">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="post">
                        役職
                      </label>
                      <CustomTag type="optional" />
                    </div>
                    <div className="w-full">
                      <Dropdown
                        error={formErrors.post}
                        errorText={formErrors.post}
                        placeholder={"選択してください"}
                        options={roleOptions}
                        value={formData.post}
                        tabindex={20}
                        onChange={(value: any) => {setFormData((prev: any) => ({...prev, post: value,})); markDirty();}}
                      />
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #13 メッセージ */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center gap-2 mb-2">
                      <label className="block text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="department_message">
                        メッセージ
                      </label>
                      <CustomTag type="required" />
                    </div>
                    <CustomTextarea
                      error={formErrors.department_message}
                      errorText={formErrors.department_message}
                      rows={3}
                      maxLength={400}
                      id="department_message"
                      name="department_message"
                      value={formData.department_message}
                      onChange={handleChange}
                      placeholder="入力してください"
                      tabindex={21}
                    />
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #14 給与形態 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-start">
                    <div className="min-w-[10.875rem] flex items-center gap-2 mt-2">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="pay_type">
                        給与形態
                      </label>
                      <CustomTag type="required" />
                    </div>
                    <div className="w-full">
                      <Dropdown
                        error={formErrors.pay_type}
                        errorText={formErrors.pay_type}
                        placeholder={"選択してください"}
                        options={payTypes}
                        value={formData.pay_type}
                        tabindex={22}
                        onChange={(value: any) =>{
                          markDirty();
                          setFormData((prev: any) => ({ ...prev, pay_type: value,}));
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #15 年収 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-start">
                    <div className="min-w-[10.875rem] flex items-center gap-2 mt-2">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="annual_income_range">
                        年収
                      </label>
                      <CustomTag type="optional" />
                    </div>
                    <div className="flex-1">
                      <div className="flex-1 flex items-center gap-4">
                        <div className="w-[6.25rem]">
                          <TextInput
                            size="md"
                            required={true}
                            type="number"
                            min={1}
                            max={9999}
                            id="from_income"
                            name="from_income"
                            value={formData.from_income}
                            onChange={handleChangeNumber}
                            placeholder=""
                            error={formErrors.from_income}
                            maxLength={4}
                            tabindex={23}
                          />
                        </div>
                        <span>-</span>
                        <div className="w-[6.25rem]">
                          <TextInput
                            size="md"
                            required={true}
                            type="number"
                            min={1}
                            max={9999}
                            id="to_income"
                            name="to_income"
                            value={formData.to_income}
                            onChange={handleChangeNumber}
                            placeholder=""
                            error={formErrors.to_income}
                            maxLength={4}
                            tabindex={24}
                          />
                        </div>
                        <p className="shrink-0 text-sm alu-text-base-2 w-[2.25rem]">万円</p>
                      </div>
                      {(formErrors.from_income || formErrors.to_income) && (
                        <p className="alu-text-error text-sm mt-2">*{formErrors.from_income || formErrors.to_income}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #16 月額 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-start">
                    <div className="min-w-[10.875rem] flex items-center gap-2 mt-2">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="monthly_fee">
                        月額
                      </label>
                      <CustomTag type="optional" />
                    </div>
                    <div className="flex-1">
                      <div className="flex-1 flex items-center gap-4">
                        <div className="w-[6.25rem]">
                          <TextInput
                            size="md"
                            required={true}
                            type="number"
                            min={1}
                            max={999}
                            id="from_monthly_fee"
                            name="from_monthly_fee"
                            value={formData.from_monthly_fee}
                            onChange={handleChangeNumber}
                            placeholder=""
                            error={formErrors.from_monthly_fee}
                            maxLength={3}
                            tabindex={25}
                          />
                        </div>
                        <span>-</span>
                        <div className="w-[6.25rem]">
                          <TextInput
                            size="md"
                            required={true}
                            type="number"
                            min={1}
                            max={999}
                            id="to_monthly_fee"
                            name="to_monthly_fee"
                            value={formData.to_monthly_fee}
                            onChange={handleChangeNumber}
                            placeholder=""
                            error={formErrors.to_monthly_fee}
                            maxLength={3}
                            tabindex={26}
                          />
                        </div>
                        <p className="shrink-0 text-sm alu-text-base-2 w-[2.25rem]">万円</p>
                      </div>
                      {(formErrors.from_monthly_fee || formErrors.to_monthly_fee) && (<p className="alu-text-error text-sm mt-2">*{formErrors.from_monthly_fee || formErrors.to_monthly_fee}</p>)}  
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #17 賞与 not yet */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-center">
                    <label className="block shrink-0 min-w-[10.875rem] text-sm font-bold alu-text-base-2 pointer-events-none" htmlFor="bonus">
                      賞与
                    </label>
                    <div className="flex-1 flex items-center gap-4">
                      <p className="shrink-0 text-sm alu-text-base-2">年</p>
                      <div className="w-[6.25rem]">
                        <TextInput
                          size="md"
                          type="number"
                          min={1}
                          max={99}
                          id="bonus"
                          name="bonus"
                          value={formData.bonus}
                          onChange={handleChangeNumber}
                          placeholder=""
                          maxLength={2}
                          tabindex={27}
                        />
                      </div>
                      <p className="shrink-0 text-sm alu-text-base-2 w-[2.25rem]">回</p>
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #18 昇給 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-start">
                    <div className="min-w-[10.875rem] flex items-center gap-2 mt-2">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="salary_increase">
                        昇給
                      </label>
                      <CustomTag type="required" />
                    </div>
                    <div className="flex-1">
                      <RadioGroup
                        name={"salary_increase"}
                        options={hasSalaryIncrement}
                        value={formData.salary_increase}
                        onChange={(value: any) =>{
                          markDirty();
                          setFormData((prev: any) => ({
                            ...prev,
                            salary_increase: value,
                          }));
                        }}
                        error={formErrors.salary_increase}
                        errorText={formErrors.salary_increase}
                        tabindex={28}
                      />
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #19 固定残業代 not yet */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-start">
                    <div className="min-w-[10.875rem] flex items-center gap-2 mt-2">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="fixed_ot_pay">
                        固定残業代
                      </label>
                      <CustomTag type="required" />
                    </div>
                    <div className="flex-1 flex flex-col gap-2">
                      <RadioGroup
                        name={"fixed_ot_pay"}
                        options={fixedOTpayment}
                        value={formData.fixed_ot_pay}
                        onChange={(value: any) =>{
                          markDirty();
                          setFormData((prev: any) => ({...prev, fixed_ot_pay: value,}))
                        }}
                        error={formErrors.fixed_ot_pay}
                        errorText={formErrors.fixed_ot_pay}
                        tabindex={29}
                      />

                      {increaseForOverTime.map((increaseFor, idx) => (
                        <CheckboxButton
                          key={idx}
                          name={increaseFor.name}
                          label={increaseFor.label}
                          value={increaseFor.value}
                          tabindex={30}
                          onChange={() => {
                            markDirty();
                            const newList = increaseForOverTime.map(
                              (item, index) => idx === index ? { ...item, value: !item.value } : { ...item }
                            );
                            setIncreaseForOverTime(newList);
                          }}
                        />
                      ))}
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #20 残業代備考 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center justify-between mb-2">
                      <label className="block text-sm font-bold alu-text-base-2 pointer-events-none" htmlFor="ot_pay_note">
                        残業代備考
                      </label>
                    </div>
                    <CustomTextarea
                      required={formData.fixed_ot_pay}
                      rows={3}
                      maxLength={100}
                      id="ot_pay_note"
                      name="ot_pay_note"
                      value={formData.ot_pay_note}
                      onChange={handleChange}
                      placeholder="入力してください"
                      error={formErrors.ot_pay_note}
                      errorText={formErrors.ot_pay_note}
                      tabindex={31}
                    />
                  </div>
                  <div className="w-[25%]">
                    <p className="text-xs alu-text-base-1 mt-[27px]">固定残業代を有にした場合は必須です。</p>
                  </div>
                </div>

                {/* #21 賃金備考 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center justify-between mb-2">
                      <label className="block text-sm font-bold alu-text-base-2 pointer-events-none" htmlFor="wage_remarks">
                        賃金備考
                      </label>
                    </div>
                    <CustomTextarea
                      required={formData.salary_increase}
                      rows={3}
                      maxLength={400}
                      id="wage_remarks"
                      name="wage_remarks"
                      value={formData.wage_remarks}
                      onChange={handleChange}
                      placeholder="入力してください"
                      error={formErrors.wage_remarks}
                      errorText={formErrors.wage_remarks}
                      tabindex={32}
                    />
                  </div>
                  <div className="w-[25%]">
                    <p className="text-xs alu-text-base-1 mt-[27px]">昇給を有にした場合は必須です。</p>
                  </div>
                </div>

                {/* #22 勤務形態 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-start">
                    <div className="min-w-[10.875rem] flex items-center gap-2 mt-2">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="working_style">
                        勤務形態
                      </label>
                      <CustomTag type="optional" />
                    </div>
                    <div className="w-full">
                      <Dropdown
                        error={formErrors.working_style}
                        errorText={formErrors.working_style}
                        placeholder={"選択してください"}
                        options={workingStyles}
                        value={formData.working_style}
                        tabindex={33}
                        onChange={(value: any) => {
                          markDirty();
                          setFormData((prev: any) => ({ ...prev, working_style: value,}));
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #23 勤務時間 not yet */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-start">
                    <div className="min-w-[10.875rem] flex items-center gap-2 mt-2">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="working_hour">
                        勤務時間
                      </label>
                      <CustomTag type="required" />
                    </div>
                    <div className="w-full">
                      <div className="flex-1 flex items-center gap-4">
                        <div className="flex items-center gap-2">
                          <div className="w-full xl:w-[6.25rem]">
                            <TimeInput
                              size="md"
                              required={true}
                              type="text"
                              maxLength={2}
                              id="from_working_hour"
                              name="from_working_hour"
                              value={formData.from_working_hour}
                              onChange={handleChangeTime}
                              placeholder="00"
                              error={formErrors.from_working_hour}
                              errorText=""
                              tabindex={34}
                            />
                          </div>
                          <span>:</span>
                          <div className="w-full xl:w-[6.25rem]">
                            <TimeInput
                              size="md"
                              required={true}
                              type="text"
                              maxLength={2}
                              id="from_working_minute"
                              name="from_working_minute"
                              value={formData.from_working_minute}
                              onChange={handleChangeTime}
                              placeholder="00"
                              error={formErrors.from_working_minute}
                              errorText=""
                              tabindex={35}
                            />
                          </div>
                        </div>
                        <span>-</span>
                        <div className="flex items-center gap-2">
                          <div className="w-full xl:w-[6.25rem]">
                            <TimeInput
                              size="md"
                              required={true}
                              type="text"
                              maxLength={2}
                              id="to_working_hour"
                              name="to_working_hour"
                              value={formData.to_working_hour}
                              onChange={handleChangeTime}
                              placeholder="00"
                              error={formErrors.to_working_hour}
                              errorText=""
                              tabindex={36}
                            />
                          </div>
                          <span>:</span>
                          <div className="w-full xl:w-[6.25rem]">
                            <TimeInput
                              size="md"
                              required={true}
                              type="text"
                              maxLength={2}
                              id="to_working_minute"
                              name="to_working_minute"
                              value={formData.to_working_minute}
                              onChange={handleChangeTime}
                              placeholder="00"
                              error={formErrors.to_working_minute}
                              errorText=""
                              tabindex={37}
                            />
                          </div>
                        </div>
                      </div>
                      {workingHourErrorMsg && (
                        <p className="alu-text-error text-sm mt-2">
                          *{workingHourErrorMsg}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #24 休憩時間 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center gap-2 mb-2">
                      <label className="block text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="break_time">
                        休憩時間
                      </label>
                      <CustomTag type="required" />
                    </div>
                    <CustomTextarea
                      required={true}
                      rows={3}
                      maxLength={100}
                      id="break_time"
                      name="break_time"
                      value={formData.break_time}
                      onChange={handleChange}
                      placeholder="入力してください"
                      error={formErrors.break_time}
                      errorText={formErrors.break_time}
                      tabindex={38}
                    />
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #25 平均残業時間 not yet */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-start">
                    <div className="min-w-[10.875rem] flex items-center gap-2 mt-2">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="avg_ot_hours">
                        平均残業時間
                      </label>
                      <CustomTag type="optional" />
                    </div>
                    <div className="flex-1">
                      <div className="flex-1 flex items-center gap-4">
                        <p className="shrink-0 text-sm alu-text-base-2">月</p>
                        <div className="w-[6.25rem]">
                          <TextInput
                            size="md"
                            required={true}
                            type="number"
                            min={0}
                            max={45}
                            id="avg_ot_hours"
                            name="avg_ot_hours"
                            value={formData.avg_ot_hours}
                            onChange={handleChangeNumber}
                            placeholder=""
                            error={formErrors.avg_ot_hours}
                            maxLength={2}
                            tabindex={39}
                          />
                        </div>
                        <p className="shrink-0 text-sm alu-text-base-2 w-[2.25rem]">時間</p>
                      </div>
                      {formErrors.avg_ot_hours && (<p className="alu-text-error text-sm mt-2">*{formErrors.avg_ot_hours}</p>)}
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #26 休日休暇 not yet */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center gap-2 mb-4">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="holiday_vacation">
                        休日休暇
                      </label>
                      <CustomTag type="required" />
                    </div>
                    <div className="w-full xl:w-[80%] 2xl:w-[60%] mb-4">
                      <RadioGroup
                        radioWidth={"50%"}
                        flexWrap={true}
                        gapSize={"16px"}
                        colGapSize={"16px"}
                        name={"holiday_vacation"}
                        options={holidayAndVacationsRadioOptions}
                        value={formData.holiday_vacation}
                        tabindex={40}
                        onChange={(value: any) => {
                          markDirty();
                          setFormData((prev: any) => ({ ...prev, holiday_vacation: value,}));
                        }}
                        error={formErrors.holiday_vacation}
                        errorText={formErrors.holiday_vacation}
                      />
                    </div>
                    <div className="w-full xl:w-[80%] 2xl:w-[60%] flex flex-wrap gap-y-4">
                      {maternityLeave.map((maternity, idx) => (
                        <div key={idx} className="w-[50%]">
                          <CheckboxButton
                            name={maternity.name}
                            label={maternity.label}
                            value={maternity.value}
                            tabindex={41}
                            onChange={() => {
                              markDirty();
                              const newList = maternityLeave.map((item, index) =>
                                idx === index ? { ...item, value: !item.value } : { ...item }
                              );
                              setMaternityLeave(newList);
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #27 休日休暇備考 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center justify-between mb-2">
                      <label className="block text-sm font-bold alu-text-base-2 pointer-events-none" htmlFor="vacation_note">
                        休日休暇備考
                      </label>
                    </div>
                    <CustomTextarea
                      rows={3}
                      maxLength={400}
                      id="vacation_note"
                      name="vacation_note"
                      value={formData.vacation_note}
                      onChange={handleChange}
                      placeholder="入力してください"
                      tabindex={42}
                    />
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #28 年間休日 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-start">
                    <div className="min-w-[10.875rem] flex items-center gap-2 mt-2">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="annual_holiday" >
                        年間休日
                      </label>
                      <CustomTag type="optional" />
                    </div>
                    <div className="flex-1">
                      <div className="flex-1 flex items-center gap-4">
                        <div className="w-[6.25rem]">
                          <TextInput
                            size="md"
                            required={true}
                            type="number"
                            min={1}
                            max={365}
                            id="annual_holiday"
                            name="annual_holiday"
                            value={formData.annual_holiday}
                            onChange={handleChangeNumber}
                            placeholder=""
                            error={formErrors.annual_holiday}
                            maxLength={3}
                            tabindex={43}
                          />
                        </div>
                        <p className="shrink-0 text-sm alu-text-base-2 w-[2.25rem]">
                          日
                        </p>
                      </div>
                      {formErrors.annual_holiday && (<p className="alu-text-error text-sm mt-2">*{formErrors.annual_holiday}</p>)}
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #29 雇用形態 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-start">
                    <div className="min-w-[10.875rem] flex items-center gap-2 mt-2">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="employment_status">
                        雇用形態
                      </label>
                      <CustomTag type="required" />
                    </div>
                    <div className="w-full">
                      <Dropdown
                        error={formErrors.employment_status}
                        errorText={formErrors.employment_status}
                        placeholder={"選択してください"}
                        options={employmentStatus}
                        value={formData.employment_status}
                        tabindex={44}
                        onChange={(value: any) =>{
                          markDirty();
                          setFormData((prev: any) => ({...prev, employment_status: value,}));
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #30 雇用形態備考 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center justify-between mb-2">
                      <label className="block text-sm font-bold alu-text-base-2 pointer-events-none" htmlFor="employment_status_note">
                        雇用形態備考
                      </label>
                    </div>
                    <CustomTextarea
                      rows={3}
                      maxLength={400}
                      id="employment_status_note"
                      name="employment_status_note"
                      value={formData.employment_status_note}
                      onChange={handleChange}
                      placeholder="入力してください"
                      tabindex={45}
                    />
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #31 試用期間 not yet */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-start">
                    <div className="min-w-[10.875rem] flex items-center gap-2 mt-2">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="trial_period">
                        試用期間
                      </label>
                      <CustomTag type="required" />
                    </div>
                    <div className="flex-1 flex flex-col gap-x-2">
                      <RadioGroup
                        name={"trial_period"}
                        options={probationDuration}
                        value={formData.trial_period}
                        onChange={(value: any) =>{
                          markDirty();
                          setFormData((prev: any) => ({ ...prev, trial_period: value}));
                        }}
                        error={formErrors.trial_period}
                        errorText={formErrors.trial_period}
                        tabindex={46}
                      />
                      {formData.trial_period && (
                        <>
                        <div className="flex-1 flex items-center gap-4 mt-2">
                          <div className="w-[6.25rem]">
                            <TimeInput
                              size="md"
                              required={formData.trial_period}
                              type="text"
                              maxLength={2}
                              id="trial_period_time"
                              name="trial_period_time"
                              value={formData.trial_period_time}
                              onChange={handleChangeTime}
                              placeholder=""
                              error={formErrors.trial_period_time}
                              tabindex={47}
                            />
                          </div>
                          <p className="shrink-0 text-sm alu-text-base-2">ヶ月</p>
                        </div>
                        {formErrors.trial_period_time && (<p className="alu-text-error text-sm mt-2">*{formErrors.trial_period_time}</p>)}
                        </>
                      )}
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #32 保険待遇 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center gap-2 mb-4">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="insurance_benefit">
                        保険待遇
                      </label>
                      <CustomTag type="optional" />
                    </div>
                    <div className="w-full xl:w-[80%] 2xl:w-[60%] flex flex-row flex-wrap gap-y-4">
                      {insuranceBenefits.map((insurance, idx) => (
                        <div key={idx} className="w-[50%]">
                          <CheckboxButton
                            name={insurance.name}
                            label={insurance.label}
                            value={insurance.value}
                            tabindex={48}
                            onChange={() => {
                              markDirty();
                              const newList = insuranceBenefits.map((item, index) =>
                                  idx === index ? { ...item, value: !item.value } : { ...item }
                              );
                              setInsuranceBenefits(newList);
                            }}
                          />
                        </div>
                      ))}
                      {formErrors.insurance_benefits && (<p className="alu-text-error text-sm">*{formErrors.insurance_benefits}</p>)}
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #33 保険待遇備考 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center justify-between mb-2">
                      <label className="block text-sm font-bold alu-text-base-2 pointer-events-none" htmlFor="insurance_benefit_note">
                        保険待遇備考
                      </label>
                    </div>
                    <CustomTextarea
                      rows={3}
                      maxLength={400}
                      id="insurance_benefit_note"
                      name="insurance_benefit_note"
                      value={formData.insurance_benefit_note}
                      onChange={handleChange}
                      placeholder="入力してください"
                      tabindex={49}
                    />
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #34 諸手当 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center gap-2 mb-4">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="allowance">
                        諸手当
                      </label>
                      <CustomTag type="optional" />
                    </div>
                    <div className="w-full xl:w-[80%] 2xl:w-[60%] flex flex-row flex-wrap gap-y-4">
                      {allowances.map((allowance, idx) => (
                        <div key={idx} className="w-[50%]">
                          <CheckboxButton
                            name={allowance.name}
                            label={allowance.label}
                            value={allowance.value}
                            tabindex={50} 
                            onChange={() => {
                              markDirty();
                              const newList = allowances.map((item, index) => 
                                idx === index ? { ...item, value: !item.value } : { ...item }
                              );
                              setAllowances(newList);
                            }}
                          />
                        </div>
                      ))}
                      {formErrors.allowances && (<p className="alu-text-error text-sm">*{formErrors.allowances}</p>)}
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #35 諸手当備考 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center justify-between mb-2">
                      <label className="block text-sm font-bold alu-text-base-2 pointer-events-none" htmlFor="allowance_note">
                        諸手当備考
                      </label>
                    </div>
                    <CustomTextarea
                      rows={3}
                      maxLength={400}
                      id="allowance_note"
                      name="allowance_note"
                      value={formData.allowance_note}
                      onChange={handleChange}
                      placeholder="入力してください"
                      tabindex={51}
                    />
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #36 受動喫煙対策 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center gap-2 mb-4">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="smoking_measures">
                        受動喫煙対策
                      </label>
                      <CustomTag type="required" />
                    </div>
                    <div className="w-full xl:w-[80%] 2xl:w-[60%]">
                      <RadioGroup
                        radioWidth={"50%"}
                        flexWrap={true}
                        gapSize={"16px"}
                        colGapSize={"16px"}
                        name={"smoking_measures"}
                        options={measuresAgainstPassiveSmokingOptions}
                        value={formData.smoking_measure}
                        onChange={(value: any) => {markDirty(); setFormData((prev: any) => ({ ...prev, smoking_measure: value, }));}}
                        error={formErrors.smoking_measure}
                        errorText={formErrors.smoking_measure}
                        tabindex={52}
                      />
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #37 選考の流れ */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center gap-2 mb-2">
                      <label className="block text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="selection_process">
                        選考の流れ
                      </label>
                      <CustomTag type="required" />
                    </div>
                    <CustomTextarea
                      required={true}
                      rows={3}
                      maxLength={400}
                      id="selection_process"
                      name="selection_process"
                      value={formData.selection_process}
                      onChange={handleChange}
                      placeholder="入力してください"
                      error={formErrors.selection_process}
                      errorText={formErrors.selection_process}
                      tabindex={53}
                    />
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #38 希望年齢 not yet */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-start">
                    <div className="min-w-[10.875rem] flex items-center gap-2 mt-2">
                      <label className="block text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="desired_age">
                        希望年齢
                      </label>
                      <CustomTag type="required" />
                    </div>
                    <div className="flex-1">
                      <div className="mb-2 flex items-center gap-4">
                        <div className="w-[6.25rem]">
                          <TextInput
                            size="md"
                            type="number"
                            min={1}
                            max={99}
                            id="from_age"
                            name="from_age"
                            value={formData.from_age}
                            onChange={handleChangeNumber}
                            placeholder=""
                            error={formErrors.from_age}
                            maxLength={2}
                            tabindex={54}
                          />
                        </div>
                        <span>-</span>
                        <div className="w-[6.25rem]">
                          <TextInput
                            size="md"
                            type="number"
                            min={1}
                            max={99}
                            id="to_age"
                            name="to_age"
                            value={formData.to_age}
                            onChange={handleChangeNumber}
                            placeholder=""
                            error={formErrors.to_age}
                            maxLength={2}
                            tabindex={55}
                          />
                        </div>
                        <p className="shrink-0 text-sm alu-text-base-2 w-[2.25rem]">歳</p>
                      </div>
                      {(formErrors.from_age || formErrors.to_age) && (<p className="alu-text-error text-sm mt-2 mb-2">*{formErrors.from_age || formErrors.to_age}</p>)}
                      {noAgeLimit.map((noAge, idx) => (
                        <CheckboxButton
                          key={idx}
                          name={noAge.name}
                          label={noAge.label}
                          value={noAge.value}
                          onChange={() => handleChangeNoAgeLimit(noAge, idx)}
                          tabindex={56}
                        />
                      ))}
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #39 企業情報 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center gap-2 mb-2">
                      <label className="block text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="company_info">
                        企業情報
                      </label>
                    </div>
                    <CustomTextarea
                      rows={3}
                      maxLength={400}
                      id="company_info"
                      name="company_info"
                      value={formData.company_info}
                      onChange={handleChange}
                      placeholder="入力してください"
                      error={formErrors.company_info}
                      errorText={formErrors.company_info}
                      disabled={true}
                    />
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #40 採用人数 */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-start">
                    <div className="min-w-[10.875rem] flex items-center gap-2 mt-2">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="employee_quantity">
                        採用人数
                      </label>
                      <CustomTag type="required" />
                    </div>
                    <div className="flex-1">
                      <div className="flex-1 flex items-center gap-4">
                        <div className="w-[6.25rem]">
                          <TextInput
                            size="md"
                            required={true}
                            type="number"
                            min={1}
                            max={999}
                            id="employee_quantity"
                            name="employee_quantity"
                            value={formData.employee_quantity}
                            onChange={handleChangeNumber}
                            placeholder=""
                            error={formErrors.employee_quantity}
                            maxLength={3}
                            tabindex={57}
                          />
                        </div>
                        <p className="shrink-0 text-sm alu-text-base-2 w-[2.25rem]">人</p>
                      </div>
                      {formErrors.employee_quantity && (<p className="alu-text-error text-sm mt-2">*{formErrors.employee_quantity}</p>)}
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #41 タグ */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-center">
                    <label className="block shrink-0 min-w-[10.875rem] text-sm font-bold alu-text-base-2 pointer-events-none" htmlFor="tag">
                      タグ
                    </label>
                    <div className="w-full">
                      <TextInput
                        customClassName="!h-[45px]"
                        maxLength={100}
                        id="tag"
                        name="tag"
                        value={formData.tag}
                        onChange={handleChange}
                        placeholder="入力してください"
                        error={formErrors.tag}
                        errorText={formErrors.tag}
                        tabindex={58}
                      />
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #42 その他特記事項（管理用） */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%]">
                    <div className="flex items-center justify-between mb-2">
                      <label className="block text-sm font-bold alu-text-base-2 pointer-events-none" htmlFor="admin_note">
                        その他特記事項（管理用）
                      </label>
                    </div>
                    <CustomTextarea
                      rows={3}
                      maxLength={10000}
                      id="admin_note"
                      name="admin_note"
                      value={formData.admin_note}
                      onChange={handleChange}
                      placeholder="入力してください"
                      tabindex={59}
                    />
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #43 募集ステータス */}
                <div className="mb-6 gap-6 flex">
                  <div className="w-[75%] flex items-start">
                    <div className="min-w-[10.875rem] flex items-center gap-2 mt-2">
                      <label className="block shrink-0 text-sm leading-none font-bold alu-text-base-2 pointer-events-none" htmlFor="recruitment_status">
                        募集ステータス
                      </label>
                      <CustomTag type="required" />
                    </div>
                    <div className="w-full">
                      <Dropdown
                        error={formErrors.recruitment_status}
                        errorText={formErrors.recruitment_status}
                        placeholder={"選択してください"}
                        options={recruitmentStatus}
                        value={formData.recruitment_status}
                        onChange={(value: any) => handleChangeRecruitmentStatus(value)}
                        tabindex={60}
                      />
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>

                {/* #44 公開予約 */}
                <div className="mb-6 flex gap-6">
                  <div className="w-[75%] flex items-start">
                    <div className="flex items-center gap-3 min-w-[10.875rem] mt-2">
                      <label className={`block shrink-0 text-sm font-bold pointer-events-none 
                        ${jobDetailData?.is_public === true || 
                        formData.recruitment_status?.value === RECRUITMENT_STATUS.PRIVATE || 
                        !formData.recruitment_status ? "text-[#BBB]" : "alu-text-base-2"}`}>
                        公開予約
                      </label>
                      <div className="flex-1">
                        <CustomSwitch checked={isPublishReserved}
                          onChange={(e: any) => handleSwitchPublished(e)}
                          disabled={jobDetailData?.is_public === true || formData.recruitment_status?.value === RECRUITMENT_STATUS.PRIVATE || !formData.recruitment_status}
                        />
                      </div>
                    </div>
                    <div className="w-full">
                      <div className="flex items-center gap-4 flex-wrap">
                        <div className="w-[264px]">
                          <CustomDatePicker
                            disabled={!isPublishReserved || formData.recruitment_status?.value === RECRUITMENT_STATUS.PRIVATE || jobDetailData.is_public}
                            minDate={new Date()}
                            maxDate={new Date(new Date().getFullYear() + 1, 11, 31)}
                            value={formData.public_schedule_date}
                            onChange={(value: any) => {markDirty();setFormData((prev: any) => ({ ...prev, public_schedule_date: value }));}}
                            error={formErrors.public_schedule_date}
                            placeholderText={""}
                            tabindex={61}
                          />
                        </div>
                        <div className="flex items-center gap-2">
                          <div className="w-[4.5rem]">
                            <TimeInput
                              size="md"
                              type="text"
                              maxLength={2}
                              id="public_schedule_hour"
                              name="public_schedule_hour"
                              value={formData.public_schedule_hour}
                              onChange={handleChangeTime}
                              placeholder="00"
                              error={formErrors.public_schedule_hour}
                              errorText=""
                              disabled={!isPublishReserved || formData.recruitment_status?.value === RECRUITMENT_STATUS.PRIVATE || jobDetailData.is_public}
                              customClassName="disabled:bg-[#F7F7F7] disabled:text-[#BBBBBB]"
                              tabindex={62}
                            />
                          </div>
                          <span>:</span>
                          <div className="w-[4.5rem]">
                            <TimeInput
                              size="md"
                              type="text"
                              maxLength={2}
                              id="public_schedule_minute"
                              name="public_schedule_minute"
                              value={formData.public_schedule_minute}
                              onChange={handleChangeTime}
                              placeholder="00"
                              error={formErrors.public_schedule_minute}
                              errorText=""
                              disabled={!isPublishReserved || formData.recruitment_status?.value === RECRUITMENT_STATUS.PRIVATE || jobDetailData.is_public}
                              customClassName="disabled:bg-[#F7F7F7] disabled:text-[#BBBBBB]"
                              tabindex={63}
                            />
                          </div>
                        </div>
                      </div>
                      {scheduleErrorMsg && (
                        <p className="alu-text-error text-sm mt-2">
                          *{scheduleErrorMsg}
                        </p>
                      )}
                      <p className="text-xs alu-text-base-1 mt-3">募集ステータスが「非公開」の場合、公開予約は使用できません。</p>
                    </div>
                  </div>
                  <div className="w-[25%]">
                    <p className="text-xs alu-text-base-1">現在時刻の1時間後から予約できます。</p>
                  </div>
                </div>

                {/* #45 募集終了日 not yet */}
                <div className="mb-6 flex gap-6">
                <div className="w-[75%] flex">
                  <label className="mt-2 block shrink-0 min-w-[10.875rem] text-sm font-bold alu-text-base-2 pointer-events-none" htmlFor="application_deadline">
                    募集終了日
                  </label>
                  <div className="w-full">
                    <div className="flex items-center gap-4 flex-wrap">
                      <div className="w-[264px]">
                        <CustomDatePicker
                          minDate={new Date()}
                          maxDate={new Date(new Date().getFullYear() + 1, 11, 31)}
                          value={formData.application_deadline}
                          onChange={(newValue: any) => {markDirty(); handleSetExpiryDate(newValue)}}
                          error={formErrors.application_deadline}
                          placeholderText={""}
                          tabindex={64}
                        />
                      </div>
                      <div className="flex items-center gap-2">
                        <div className="w-[4.5rem]">
                          <TimeInput
                            size="md"
                            type="text"
                            maxLength={2}
                            id="application_deadline_hour"
                            name="application_deadline_hour"
                            value={formData.application_deadline_hour}
                            onChange={handleChangeTime}
                            placeholder="00"
                            error={formErrors.application_deadline_hour}
                            errorText=""
                            tabindex={65}
                          />
                        </div>
                        <span>:</span>
                        <div className="w-[4.5rem]">
                          <TimeInput
                            size="md"
                            type="text"
                            maxLength={2}
                            id="application_deadline_minute"
                            name="application_deadline_minute"
                            value={formData.application_deadline_minute}
                            onChange={handleChangeTime}
                            placeholder="00"
                            error={formErrors.application_deadline_minute}
                            errorText=""
                            tabindex={66}
                          />
                        </div>
                      </div>
                    </div>
                    {applicationDeadlineErrorMsg && (
                      <p className="alu-text-error text-sm mt-2">
                        *{applicationDeadlineErrorMsg}
                      </p>
                    )}
                  </div>
                </div>
                <div className="w-[25%]"></div>
                </div>

                <div className="gap-6 flex">
                  <div className="w-[75%] pt-4 flex items-center justify-between">
                    <CustomButton onClick={() => handleCancelChange()}
                      customStyle="shrink-0" variant="text">
                      キャンセル
                    </CustomButton>
                    <div className="flex items-center gap-8 flex-1 justify-end">
                      <CustomButton 
                        type="button" 
                        variant="outline"
                        onClick={(e) => handleSubmit(e, false)}
                        disabled={(formData.recruitment_status && formData.recruitment_status.value != RECRUITMENT_STATUS.PRIVATE) || loading} 
                        tabindex={67}
                      >
                        <p>{loading && !isNavigateToPreview ? "保存中..." : "保存"}</p>
                        {loading && !isNavigateToPreview && (
                          <span><LoadingSpinner /></span>
                        )}
                      </CustomButton>
                      <CustomButton
                        type="button"
                        onClick={(e) => handleSubmit(e, true)}
                        disabled={(formData.recruitment_status && formData.recruitment_status.value == RECRUITMENT_STATUS.PRIVATE) || loading}
                      >
                        <p>{loading && isNavigateToPreview ? "保存中..." : !isPublishReserved ? "プレビューして公開" : "プレビューして公開予約"}</p>
                        {loading && isNavigateToPreview && (
                          <span><LoadingSpinner /></span>
                        )}
                      </CustomButton>
                    </div>
                  </div>
                  <div className="w-[25%]"></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Copyright view="company" />
      {showLeaveConfirm && !isNavigatingAway && <UnsaveConfirmPopup
        open={showLeaveConfirm}
        onClose={() => dispatch(setShowLeaveConfirm(false))}
        confirmContent={"編集中の内容を保存せずに終了しますか？"}
        onOtherAction={() => {dispatch(setShowLeaveConfirm(false));dispatch(setIsFormDirty(false));dispatch(setJobDetailDataTemp(null));dispatch(setJobDetailData([]));navigate("/company/job", { state: { isFromDetail: true } });}}
      />}
      {isLeavePage && <UnsaveConfirmPopup
        open={isLeavePage}
        onClose={handleCloseLeavePageConfirm}
        confirmContent={"編集中の内容を保存せずに終了しますか？"}
        onOtherAction={() => {handleCloseLeavePageConfirm();dispatch(setShowLeaveConfirm(false));dispatch(setIsFormDirty(false));dispatch(setJobDetailDataTemp(null));dispatch(setJobDetailData([]));navigate(urlLeave);}}
      />}
    </>
  );
};

export default NewJobCreation;
